var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createSlice } from '@reduxjs/toolkit';
import fetchCustomerByExternalCustomerReference from '../../adapters/CustomerAdapter';
var getInitialState = function () {
    var state = {
        isLoading: false,
        hasError: false,
        errorMessage: "",
        customerDetails: {
            contactInformation: {
                contactPerson: '',
                email: '',
                telephoneNumber: ''
            },
            name: '',
            country: '',
            vatNumber: '',
            language: '',
            scaniaRead: false,
            customerReference: '',
            scaniaLegalDocumentationSigned: false
        }
    };
    return state;
};
// Slice
var slice = createSlice({
    name: 'customer',
    initialState: getInitialState(),
    reducers: {
        setIsLoading: function (state, action) {
            state.isLoading = action.payload;
        },
        updateHasError: function (state, action) {
            state.hasError = action.payload !== '';
            state.errorMessage = action.payload;
        },
        setCustomerDetails: function (state, action) {
            state.customerDetails = action.payload;
        }
    },
});
export default slice.reducer;
// Actions
var _a = slice.actions, setIsLoading = _a.setIsLoading, updateHasError = _a.updateHasError, setCustomerDetails = _a.setCustomerDetails;
export var loadCustomerData = function (externalCustomerReference) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var FetchCustomerResponseType, CustomerResponse, error_1, message;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch(setIsLoading(true));
                return [4 /*yield*/, fetchCustomerByExternalCustomerReference(externalCustomerReference)];
            case 1:
                FetchCustomerResponseType = _a.sent();
                CustomerResponse = FetchCustomerResponseType.data;
                dispatch(setCustomerDetails(CustomerResponse));
                dispatch(setIsLoading(false));
                return [3 /*break*/, 3];
            case 2:
                error_1 = _a.sent();
                message = String(error_1);
                if (error_1 instanceof Error)
                    message = error_1.message;
                dispatch(updateHasError(message));
                dispatch(setIsLoading(false));
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
